module.exports = __webpack_public_path__ + "img/shopLogo.920da1fa.png";